"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSVoiceMailComponent = void 0;
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const account_service_1 = require("../../services/account.service");
const cpni_service_1 = require("../../services/cpni.service");
const helper_service_1 = require("../../services/helper.service");
class CSVoiceMailComponent {
    constructor(accountDetailService, helperService, modalService, cpniService, router) {
        this.accountDetailService = accountDetailService;
        this.helperService = helperService;
        this.modalService = modalService;
        this.cpniService = cpniService;
        this.router = router;
        this.ringTime = ['3', '5', '8', '10', '15'];
        this.filterAccountAccessUsers = new Array();
        this.accountAccessTempArray = new Array();
        this.sortFilterArray = ['1-10', '20 lines', '50 lines', '100 lines'];
        this.voiceSortNumber = '1-10';
        this.pager = {};
        this.showDetails = true;
        this.isVoiceMailAlreadyAdded = false;
    }
    ngOnInit() {
        this.addVoiceMailCpniButton = '<div class="px-1 cs-primary-link">+ Add Voicemail</div>';
        this.removeVoiceMailCpniButton = '<div class="px-1 cs-primary-link">– Remove Voicemail</div>';
        this.resetPinCpniButton = '<div class="cs-primary-link"><span class="pr-1 cs-bold-font text-color-blue">|</span>Reset Voicemail PIN</div>';
        this.paginationSize = -1;
        this.getNumberOfRingsInfo();
        this.validateCpni();
    }
    getNumberOfRingsInfo() {
        this.loader = true;
        this.accountDetailService.getNumberOfRingsInfo().subscribe((accountInfo) => {
            this.showDetails = accountInfo ? true : false;
            this.filterAccountAccessUsers = accountInfo;
            this.voiceSortNumber = '1-10';
            this.onSelectSort(this.voiceSortNumber);
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    setPage(page, pageSize) {
        if (this.pager.totalPages !== 0) {
            if (page < 1 || page > this.pager.totalPages) {
                return;
            }
        }
        if (pageSize === '1-10') {
            pageSize = 10;
        }
        else if (pageSize === '20 lines') {
            pageSize = 20;
        }
        else if (pageSize === '50 lines') {
            pageSize = 50;
        }
        else if (pageSize === '100 lines') {
            pageSize = 100;
        }
        // get pager object from service
        if (this.filterAccountAccessUsers !== null && this.filterAccountAccessUsers !== undefined
            && page !== undefined) {
            this.pager = this.helperService.getPager(this.filterAccountAccessUsers.length, page, pageSize);
            this.startIndex = this.pager.startIndex;
            this.endIndex = this.pager.endIndex + 1;
        }
    }
    onSelectSort(selectNumber) {
        this.setPage(1, selectNumber);
        if (selectNumber === '1-10') {
            this.sortNumber = 10;
        }
        else if (selectNumber === '20 lines') {
            this.sortNumber = 20;
        }
        else if (selectNumber === '50 lines') {
            this.sortNumber = 50;
        }
        else if (selectNumber === '100 lines') {
            this.sortNumber = 100;
        }
        this.setPage(this.pager.currentPage, this.sortNumber);
    }
    addCallRingTimeInfo(user) {
        this.loader = true;
        if (user) {
            this.accountDetailService.saveCallRingTimeInfo(user.originalMobileNumber, user.ringTime).subscribe((res) => {
                if (res) {
                    this.callSuccess = res;
                    this.getNumberOfRingsInfo();
                }
                else {
                    this.callSuccess = false;
                }
                this.successMDN = user.originalMobileNumber;
                this.loader = false;
            }, (err) => {
                this.error = err;
                this.loader = false;
            });
        }
    }
    /**
     * CIP-340 - Add Voicemail
     */
    open(content) {
        this.modalRef = this.modalService.open(content, { size: 'lg', windowClass: 'dark-modal' });
    }
    addOrRemoveVoiceMail(mdn) {
        var _a;
        this.subs = this.accountDetails.subscription.filter((e) => e.mobileNumber === mdn);
        this.helperService.onNavigate('/buy/shopping-cart/features/' + ((_a = this.subs[0]) === null || _a === void 0 ? void 0 : _a.subscriptionId) + '?isChangeFeature=true&id=cat550006');
    }
    removeVoicemailPopUp(mdn) {
        this.subs = this.accountDetails.subscription.filter((e) => e.mobileNumber === mdn);
        this.selectSubToremoveVoicemail = this.subs;
        this.open(this.removeVoicemailPopup);
    }
    validateCpni() {
        this.cpniService.cpinCheck().subscribe((res) => {
            const check = res;
            if (check.cpniRequired) {
                this.cpinRequired = true;
            }
            else {
                this.cpinRequired = false;
            }
        }, (err) => {
            this.error = err;
        });
    }
    filterSubscriptions(mdn) {
        if (mdn) {
            this.subscription = this.accountDetails.subscription.filter((e) => e.mobileNumber === mdn);
            return true;
        }
        return false;
    }
    /**
     * reset voicemail pin
     */
    resetVoicemailPin(mdn) {
        this.loader = true;
        this.resetPinMdn = mdn;
        this.accountDetailService.resetVoiceMailPin(mdn).subscribe((res) => {
            this.loader = false;
            this.isResetPinSuccessfull = res;
        }, (err) => {
            this.loader = false;
            this.error = err;
        });
    }
    /**
     * redirect to Features page to remove the feature
     */
    removeVoicemail() {
        var _a;
        this.helperService.onNavigate('/buy/shopping-cart/features/' + ((_a = this.subs[0]) === null || _a === void 0 ? void 0 : _a.subscriptionId) + '?isChangeFeature=true&id=cat550006');
    }
}
exports.CSVoiceMailComponent = CSVoiceMailComponent;
//# sourceMappingURL=voicemail.component.js.map